import { escapeSlotName } from './layout';
export function getCompletedSlotMeta(s) {
  const meta = {
    ...s
  };
  if (!meta.type || meta.type === 'normal') {
    var _meta$frozen, _meta$allowDeleteChil;
    meta.type = 'normal';
    meta.frozen = (_meta$frozen = meta.frozen) !== null && _meta$frozen !== void 0 ? _meta$frozen : !(meta.containerRef || meta.selector);
    meta.allowDeleteChildren = (_meta$allowDeleteChil = meta.allowDeleteChildren) !== null && _meta$allowDeleteChil !== void 0 ? _meta$allowDeleteChil : !meta.frozen;
    meta.beforeDrop = meta.beforeDrop || (() => true);
  }
  meta.id = escapeSlotName(meta.id);
  return meta;
}
//# sourceMappingURL=components.js.map
